import type { Item } from '@/lib/api/types/items';
import type { CustomFieldsTabAdapter, TypedFieldValue } from '../types';

export const createReadOnlyCustomFieldsAdapter = ({
  item: _item,
}: {
  item: Item;
}): CustomFieldsTabAdapter => {
  const isEditable = (_fieldId: string): boolean => false;
  const isDisabled = (_fieldId: string): boolean => false;
  const isVisible = (_fieldId: string): boolean => true;
  const updateFieldValue = async (
    _fieldId: string,
    _values: TypedFieldValue[],
  ): Promise<void> => {};

  return {
    isEditable,
    isDisabled,
    isVisible,
    updateFieldValue,
  };
};
